<ion-content class="ion-padding">
  <section class="h-full flex flex-col justify-center items-center text-center gap-3">

    <ion-icon size="large" name="cloud-offline-outline"></ion-icon>

    <p class="font-semibold">
      {{ "OFFLINE.TITLE" | translate }}
    </p>
    @if (loading()) {
      <ion-button disabled>
        <ion-spinner name="circular"></ion-spinner>
      </ion-button>
    } @else {
      <ion-button (click)="refresh()">
        {{ 'OFFLINE.BUTTON.TRY_AGAIN' | translate }}
      </ion-button>
    }
  </section>
</ion-content>
